import axios from 'axios';
import md5 from 'js-md5';
// import jwt_decode from "jwt-decode";
import { Toast } from "vant";
import store from "../store/index";
import { getLanguage, guid } from "@/utils/index";
import router from "../router";
import Aes from "@/utils/aes.js";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://gateway.qqlive.online' : '/commonApi', // api 的 base_url
  timeout: 50000, // 请求超时时间
  withCredentials: true
})

// request拦截器
service.interceptors.request.use(
  config => {
    const timer = new Date().getTime();
    const uid = localStorage.getItem('uid') || guid();
    const sign = md5(`${uid}jgyh,kasd${timer}`);

    config.headers['OS'] = "0";
    config.headers['X-Language'] = getLanguage(store.state.supportLanguage);
    config.headers['Accept-Language'] = getLanguage(store.state.supportLanguage);
    config.headers['X-AppVersion'] = `1.0.0.0`;
    config.headers['P-G'] = `N`;
    config.headers['appId'] = `QQlive`;
    config.headers['X-UDID'] = uid;
    config.headers['X-Timestamp'] = timer;
    config.headers['X-Sign'] = sign;
    config.headers['Content-type'] = 'application/json;charset=UTF-8';
    config.headers['N-L'] = 'Y';
    config.headers['P-AE'] = `1`;

    if (localStorage.getItem('token')) {
      config.headers['Authorization'] = `HSBox ${localStorage.getItem('token')}`;
    }
    
    // 参数加密
    if (config.headers['P-AE'] == '1' && config.method === "post") {
      config.data = Aes.encryptLast(config.data);
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status;
    if (String(code) !== '200') {
      return Promise.reject('error');
    } else {
      if (response.config.headers['P-AE'] == '1' && response.config.method == 'post') {
        response.data = Aes.decryptLast(response.data);
      }
      return response.data;
    }
  },
  error => {
    let code = (error.response.data && error.response.data.code) || 0;
    let msg = (error.response.data && error.response.data.msg) || (error.response.data && error.response.data.desc) || "";
    if (code == 991 || code == 992 || code == 993) {
      // 退出后个人数据需要清除
      store.commit("setState", { member: null });
      localStorage.removeItem("token");
      router.replace("/login");
    }

    if (msg) {
      Toast(msg);
    }

    return Promise.reject(error)
  }
)
export default service
